import { InternalLocale, RFC4646Locale } from './types';
import { INTERNAL_TO_RFC4646_LOCALES, RFC4646_TO_INTERNAL_LOCALES, INTERNAL_TO_STRIPE_LOCALES, } from './constants';
export const isInternalLocale = (locale) => Object.values(InternalLocale).some((cwLocale) => cwLocale === locale);
const getLocale = (locale, source) => {
    if (!isInternalLocale(locale)) {
        return null;
    }
    return source[locale];
};
/**
 * Transforms Catawiki internal into RFC 4646 code format. Returns null if the
 * input parameter does not represent CW locale code. Case-sensitive.
 */
export const getRFC4646Locale = (locale) => getLocale(locale, INTERNAL_TO_RFC4646_LOCALES);
/**
 * Transforms Catawiki internal into code format for Stripe. Returns null if the
 * input parameter does not represent CW locale code. Case-sensitive.
 *
 * @see https://stripe.com/docs/js/appendix/supported_locales
 */
export const getStripeLocale = (locale) => getLocale(locale, INTERNAL_TO_STRIPE_LOCALES);
export const isRFC4646Locale = (locale) => Object.values(RFC4646Locale).some((l) => l === locale);
/**
 * Transforms RFC4646 code into Catawiki internal format. Returns null if the
 * input parameter does not represent RFC4646 locale code. Case-sensitive.
 */
export const getInternalLocaleFromRFC4646Locale = (locale) => {
    if (!isRFC4646Locale(locale)) {
        return null;
    }
    return RFC4646_TO_INTERNAL_LOCALES[locale];
};
